import { useOnline } from '@/components/ClusterBits'
import { StorageInventory, loadInventory } from '@/components/StorageInventory'
import { AppTabs, INFRA_TABS } from '@/components/AppTabs'
import { PageTitle } from '@/components/ui'
import { useNow } from '@/hooks/useNow'

/**
 * Storage, the infra pack's third page (/infra/storage, 2026-10-31): every
 * drive, filesystem, share, Kubernetes volume, cloud store and backup, from
 * GET /api/storage/inventory (components/StorageInventory.tsx draws it).
 * Online only; refreshed every 30 s while it shows, as the server's copy is.
 */
export const InfraStorageView = () => {
  const now = useNow(30_000)
  const inventory = useOnline(loadInventory, 30_000)
  return (
    <div className="max-w-2xl" data-testid="infra-storage-page">
      <PageTitle>Storage</PageTitle>
      <AppTabs tabs={INFRA_TABS} label="Infrastructure" />
      <StorageInventory {...inventory} now={now} />
    </div>
  )
}
